<template>
  <div class="table-search-items__pagination">
    <div class="pagination">
      <div class="pagination__items">
        <button v-if="totalPages > 1 && currentPage !== 1" class="prev" @click="customPageChange(currentPage - 1)">
            <img src="/img/svg/common/full-arrow-right.svg" alt=""/>
        </button>
        <template v-for="page in pages">
          <button v-if="
                    totalPages > 1
                    && (
                      ((page + 2) >= currentPage && page <= currentPage)
                      || ((page - 2) <= currentPage && page > currentPage)
                      || ((currentPage - 2) <= 0 && page <= 5)
                      || ((currentPage + 3) >= totalPages && page >= totalPages - 6)
                    )
            " :class="'page' + (page === currentPage ? ' active' : '')" @click="customPageChange(page)"
          >{{ page }}
          </button>
        </template>
        <div v-if="totalPages - 4 >= currentPage && totalPages !==5 && totalPages !== 6" class="dots"
             @click="customPageChange(currentPage + 3 + ((currentPage - 3 < 0) ? -(currentPage - 3) : 0))">...</div>
        <button v-if="totalPages - 4 >= currentPage && totalPages !==5" class="pagination__item" @click="customPageChange(totalPages)">
          {{ totalPages }}
        </button>
        <button v-if="totalPages > 1 && currentPage !== totalPages" class="next"
                @click="customPageChange(currentPage + 1)">
          <img src="/img/svg/common/full-arrow-right.svg" alt=""/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "customPagination",
  props: {
    total: { type: Number, required: true },
    perPage: { type: Number, required: true },
    pageChanged: { type: Function },
    perPageChanged: { type: Function },
  },
  data() {
    return {
      currentPage: 1,
      perPageDefault: 25,
      isOpen: false,
      options: [
        { value: 15, label: "15" },
        { value: 25, label: "25" },
        { value: 50, label: "50" },
        { value: 100, label: "100" },
        { value: 300, label: "300" },
      ],
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.perPage);
    },
    pages() {
      let pages = [];
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  methods: {
    customPageChange(customCurrentPage) {
      if (this.pageChanged) {
        this.pageChanged({ currentPage: customCurrentPage,perPage: this.perPage });
      }
      this.currentPage = customCurrentPage;
    },
    setCurrentPage(page) {
      this.currentPage = page;
    }
  },
}
</script>
